import { render } from "./PageInfo.vue?vue&type=template&id=64b6fe40"
import script from "./PageInfo.vue?vue&type=script&lang=js"
export * from "./PageInfo.vue?vue&type=script&lang=js"

import "./PageInfo.vue?vue&type=style&index=0&id=64b6fe40&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__